export default __webpack_public_path__ + "media/images/zoom-aafa31ad2b87a3b2ddc29ebfdd226f87.svg";